/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Field_Additional_ContactsInputs */

const en_clients_field_additional_contacts = /** @type {(inputs: Clients_Field_Additional_ContactsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Additional contacts`)
};

const pt_br2_clients_field_additional_contacts = /** @type {(inputs: Clients_Field_Additional_ContactsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contatos adicionais`)
};

/**
* | output |
* | --- |
* | "Additional contacts" |
*
* @param {Clients_Field_Additional_ContactsInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_field_additional_contacts = /** @type {((inputs?: Clients_Field_Additional_ContactsInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Field_Additional_ContactsInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_field_additional_contacts(inputs)
	return pt_br2_clients_field_additional_contacts(inputs)
});